<template>
  <div>
    <!-- 卡片视图区域 -->
    <el-card>
<!--      <el-row :gutter="20">-->
<!--        <el-col :span="4">-->
<!--          <el-input-->
<!--            class="margin-b-10"-->
<!--            placeholder="输入关键字进行过滤"-->
<!--            clearable-->
<!--            v-model="filterText">-->
<!--          </el-input>-->

<!--          <el-tree-->
<!--            class="filter-tree"-->
<!--            :data="deptlist"-->
<!--            node-key="Id"-->
<!--            default-expand-all-->
<!--            @node-click="handleNodeClick"-->
<!--            :filter-node-method="filterNode"-->
<!--            ref="tree"-->
<!--            :props="defaultProps"-->
<!--          ></el-tree>-->
<!--        </el-col>-->
          <!-- 搜索与添加区域 -->
          <el-row :gutter="20">
            <el-col :span="8">
              <el-input placeholder="请输入内容" v-model="queryInfo.query" clearable @clear="getUserList">
                <el-button slot="append" icon="el-icon-search" @click="getUserList"></el-button>
              </el-input>
            </el-col>
            <el-col :span="4">
              <el-button type="primary" @click="showAddUser">添加用户</el-button>
            </el-col>
          </el-row>

          <!-- 用户列表区域 -->
          <el-table :data="userlist" border stripe>
            <el-table-column label="编号" type="index"></el-table-column>
            <el-table-column label="用户账号" prop="Username"></el-table-column>
            <el-table-column label="用户昵称" prop="Nickname"></el-table-column>
            <el-table-column label="角色">
              <template slot-scope="scope">
                <div v-for="(item, index) in scope.row.AdminRoleList" :key="index">
                  {{item.Name}}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="手机号码" prop="Mobile"></el-table-column>
            <el-table-column label="状态">
              <template slot-scope="scope">
                <el-switch
                  v-model="scope.row.Status"
                  :active-value="1"
                  :inactive-value="0"
                  @change="userStateChanged(scope.row)">
                </el-switch>
              </template>
            </el-table-column>
            <el-table-column label="创建时间" prop="CreatedAt"></el-table-column>
            <el-table-column label="操作" width="180px">
              <template slot-scope="scope">
                <!-- 修改按钮 -->
                <el-tooltip effect="dark" content="修改" placement="top" :enterable="false">
                  <el-button type="primary" icon="el-icon-edit" size="mini" @click="showEditDialog(scope.row)"></el-button>
                </el-tooltip>
                <!-- 删除按钮 -->
                <el-tooltip effect="dark" content="删除" placement="top" :enterable="false">
                  <el-button type="danger" icon="el-icon-delete" size="mini" @click="removeUserById(scope.row)"></el-button>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>

          <!-- 分页区域 -->
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryInfo.pagenum" :page-sizes="[10, 20, 50]" :page-size="queryInfo.pagesize" layout="total, sizes, prev, pager, next, jumper" :total="total">
          </el-pagination>

    </el-card>

    <!-- 添加用户的对话框 -->
    <el-dialog title="添加用户" :visible.sync="addDialogVisible" width="500px" @close="addDialogClosed">
      <!-- 内容主体区域 -->
      <el-form :model="addForm" :rules="addFormRules" ref="addFormRef" label-width="90px">
        <el-row v-if="addFormRules.login_type === 1">
          <el-col :span="12">
            <el-form-item label="用户昵称" prop="nickName">
              <el-input v-model="addForm.nickName" placeholder="请输入用户昵称"></el-input>
            </el-form-item>
            <el-form-item label="手机号码" prop="phonenumber">
              <el-input v-model="addForm.phonenumber" placeholder="请输入手机号码"></el-input>
            </el-form-item>
            <el-form-item label="用户名" prop="userName">
              <el-input v-model="addForm.userName" placeholder="请输入用户账号"></el-input>
            </el-form-item>
            <el-form-item label="用户性别" prop="sex">
              <el-select v-model="addForm.sex" placeholder="请选择用户性别">
                <el-option
                  v-for="item in sexOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="角色" prop="roleIds">
              <el-select
                v-model="addForm.roleIds"
                multiple
                placeholder="请选择角色">
                <el-option
                  v-for="item in roleOptions"
                  :key="item.Id"
                  :label="item.Name"
                  :value="item.Id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
<!--            <el-form-item label="归属部门" prop="value">-->
<!--              <el-select ref="elSelect" class="width-100" v-model="addForm.value" placeholder="请选择">-->
<!--                <el-option-->
<!--                  :value="addForm.value"-->
<!--                  style="height: auto"-->
<!--                >-->
<!--                  <el-tree-->
<!--                    :data="deptlist"-->
<!--                    node-key="Id"-->
<!--                    :props="defaultProps"-->
<!--                    @node-click="handleNodeClick1"-->
<!--                  ></el-tree>-->
<!--                </el-option>-->
<!--              </el-select>-->
<!--            </el-form-item>-->
            <el-form-item label="邮箱" prop="email">
              <el-input v-model="addForm.email" placeholder="请输入邮箱"></el-input>
            </el-form-item>
            <el-form-item label="用户密码" prop="password">
              <el-input v-model="addForm.password" placeholder="请输入用户密码 "></el-input>
            </el-form-item>
            <el-form-item label="状态" prop="status">
              <el-radio-group v-model="addForm.status">
                <el-radio label="1">正常</el-radio>
                <el-radio label="0">异常</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="用户类型" prop="is_admin">
              <el-radio-group v-model="addForm.is_admin">
                <el-radio label="1">前台用户</el-radio>
                <el-radio label="0">后台管理员</el-radio>
              </el-radio-group>
            </el-form-item>

          </el-col>
        </el-row>
        <el-row v-else>
          <el-form-item label="选择员工" prop="value">
            <el-cascader style="width: 336px;" @change="userChange" popper-class="selectWx" v-model="addForm.value" :props="props"></el-cascader>
          </el-form-item>
          <el-form-item label="手机号码" prop="mobile">
            <el-input v-model="addForm.phonenumber" placeholder="请输入手机号码" style="width: 336px;"></el-input>
          </el-form-item>
          <el-form-item label="角色" prop="roleIds">
            <el-select
              v-model="addForm.roleIds"
              multiple
              style="width: 336px;"
              placeholder="请选择角色">
              <el-option
                v-for="item in roleOptions"
                :key="item.Id"
                :label="item.Name"
                :value="item.Id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="状态" prop="status">
            <el-radio-group v-model="addForm.status">
              <el-radio label="1">正常</el-radio>
              <el-radio label="0">异常</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="用户类型" prop="is_admin">
            <el-radio-group v-model="addForm.is_admin">
              <el-radio label="0">前台用户</el-radio>
              <el-radio label="1">后台管理员</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-row>

        <el-form-item label="备注" prop="remark">
          <el-input type="textarea" v-model="addForm.remark" placeholder="请输入内容"></el-input>
        </el-form-item>
      </el-form>
      <!-- 底部区域 -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="addDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addUser">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 修改用户的对话框 -->
    <el-dialog title="修改用户" :visible.sync="editDialogVisible" width="500px" @close="editDialogClosed">
      <el-form :model="editForm" :rules="editFormRules" ref="editFormRef" label-width="90px">
        <el-row v-if="editForm.login_type === 1" :gutter="20">
          <el-col :span="12">
            <el-form-item label="用户昵称" prop="nickname">
              <el-input v-model="editForm.Nickname"></el-input>
            </el-form-item>
            <el-form-item label="手机号码" prop="mobile">
              <el-input v-model="editForm.Mobile"></el-input>
            </el-form-item>
            <el-form-item label="用户性别" prop="sex">
              <el-select v-model="editForm.Sex" placeholder="请选择用户性别">
                <el-option
                  v-for="item in sexOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="角色" prop="roleIds">
              <el-select
                v-model="editForm.RoleIds"
                multiple
                placeholder="请选择角色">
                <el-option
                  v-for="item in roleOptions"
                  :key="item.Id"
                  :label="item.Name"
                  :value="item.Id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
<!--            <el-form-item label="归属部门" prop="value">-->
<!--              <el-select ref="elSelect1" class="width-100" v-model="editForm.value" placeholder="请选择">-->
<!--                <el-option-->
<!--                  :value="editForm.value"-->
<!--                  style="height: auto"-->
<!--                >-->
<!--                  <el-tree-->
<!--                    :data="deptlist"-->
<!--                    node-key="Id"-->
<!--                    :props="defaultProps"-->
<!--                    @node-click="handleNodeClick2"-->
<!--                  ></el-tree>-->
<!--                </el-option>-->
<!--              </el-select>-->
<!--            </el-form-item>-->
            <el-form-item label="邮箱" prop="email">
              <el-input v-model="editForm.Email"></el-input>
            </el-form-item>
            <el-form-item label="状态" prop="status">
              <el-radio-group v-model="editForm.Status">
                <el-radio :label="1">正常</el-radio>
                <el-radio :label="0">异常</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="用户类型" prop="is_admin">
              <el-radio-group v-model="editForm.IsAdmin">
                <el-radio :label="0">前台用户</el-radio>
                <el-radio :label="1">后台管理员</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-else>
          <el-form-item label="用户" prop="nickname">
            {{ editForm.Nickname }}
          </el-form-item>
          <el-form-item label="手机号码" prop="mobile">
            <el-input v-model="editForm.Mobile" style="width: 336px;" placeholder="请输入手机号码"></el-input>
          </el-form-item>
          <el-form-item label="角色" prop="roleIds">
            <el-select
              v-model="editForm.RoleIds"
              multiple
              style="width: 336px;"
              placeholder="请选择角色">
              <el-option
                v-for="item in roleOptions"
                :key="item.Id"
                :label="item.Name"
                :value="item.Id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="状态" prop="status">
            <el-radio-group v-model="editForm.Status">
              <el-radio :label="1">正常</el-radio>
              <el-radio :label="0">异常</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="用户类型" prop="is_admin">
            <el-radio-group v-model="editForm.IsAdmin">
              <el-radio :label="0">前台用户</el-radio>
              <el-radio :label="1">后台管理员</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-row>
        <el-form-item label="备注" prop="remark">
          <el-input type="textarea" v-model="editForm.Remark" placeholder="请输入内容"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="editUserInfo">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import { chat_del, chat_get, toForm, chat_post } from '@/api'
  import FormData from 'form-data'
  export default {
    watch: {
      filterText(val) {
        this.$refs.tree.filter(val);
      }
    },
    data() {
      return {
        filterText: '',
        // 获取用户列表的参数对象
        queryInfo: {
          query: '',
          // 当前的页数
          pagenum: 1,
          // 当前每页显示多少条数据
          pagesize: 10
        },
        userlist: [],
        total: 0,
        value: '',
        // 控制添加用户对话框的显示与隐藏
        addDialogVisible: false,
        sexOptions: [{
          value: 1,
          label: '男'
        }, {
          value: 0,
          label: '女'
        }],
        // 添加用户的表单数据
        addForm: {
          status: '1',
          is_admin: '0',
          remark: '',
          nickName: '',
          phonenumber: '',
          userName: '',
          sex: '',
          email: '',
          password: '',
          roleIds: '',
          login_type: 2,
          wx_user_id: '',
          job_num: '',
        },
        wxData: {},
        props: {
          lazy: true,
          options: [],
          lazyLoad: (node, resolve) => {
            const { data = {} } = node;
            chat_get('/admin/v1/qw/dept', {
              parent_id: node.level ? data.value : '1'
            }, res => {
              if (res.status === 200) {
                let nodes = res.data.MessageContent.map(item => {
                  return {
                    value: item.Id,
                    label: item.DeptName,
                    // leaf: item.NotHasChildren,
                    type: 'org'
                  }
                })
                chat_get('/admin/v1/qw/dept/' + (data.value || 1), {}, res => {
                  if (res.status === 200) {
                    let list = res.data.MessageContent.map(item => {
                      this.wxData[item.Id] = {
                        job_num: item.JobNumber,
                        phonenumber: item.Mobile,
                        wx_user_id: item.UserId,
                        name: item.Name
                      }
                      return {
                        value: item.Id,
                        label: item.Name,
                        leaf: true,
                        type: 'user',
                        job_num: item.JobNumber,
                        Mobile: item.Mobile,
                        wx_user_id: item.UserId
                      }
                    })
                    resolve(nodes.concat(list));
                  }
                })
              }
            })
          }
        },
        roleOptions: [],
        // 添加表单的验证规则对象
        addFormRules: {
          nickName: [
            { required: true, message: '请输入用户昵称', trigger: 'blur' },
            {
              min: 2,
              max: 15,
              message: '用户名的长度在2~15个字符之间',
              trigger: 'blur'
            }
          ],
          userName: [
            { required: true, message: '请输入用户账号', trigger: 'blur' },
            {
              min: 2,
              max: 15,
              message: '用户名的长度在2~15个字符之间',
              trigger: 'blur'
            }
          ],
          // phonenumber: [
          //   { required: true, message: '请输入手机号', trigger: 'blur' },
          //   {
          //     pattern: /^((0\d{2,3}-\d{7,8})|(1[35784]\d{9}))$/,
          //     message: '请输入正确的手机号码或者座机号',
          //     trigger: 'blur'
          //   },
          // ],
          // email: [
          //   { required: true, message: '请输入邮箱地址', trigger: 'blur' },
          //   {
          //     pattern: /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((.[a-zA-Z0-9_-]{2,3}){1,2})$/,
          //     message: '请输入正确的邮箱地址',
          //     trigger: 'blur',
          //   },
          // ],
          password: [
            { required: true, message: '请输入密码', trigger: 'blur' },
            {
              min: 2,
              max: 15,
              message: '用户名的长度在2~15个字符之间',
              trigger: 'blur'
            }
          ],
          value: [
            { required: true, message: '归属部门不能为空', trigger: 'blur' },
          ]
        },
        // 控制修改用户对话框的显示与隐藏
        editDialogVisible: false,
        // 查询到的用户信息对象
        editForm: {

        },
        // 修改表单的验证规则对象
        editFormRules: {
          Nickname: [
            { required: true, message: '请输入用户名', trigger: 'blur' },
            {
              min: 2,
              max: 10,
              message: '用户名的长度在2～10个字',
              trigger: 'blur'
            }
          ],
          Mobile: [
            { required: true, message: '请输入手机号', trigger: 'blur' },
            {
              pattern: /^((0\d{2,3}-\d{7,8})|(1[35784]\d{9}))$/,
              message: '请输入正确的手机号码或者座机号',
              trigger: 'blur'
            },
          ],
          Email: [
            { required: true, message: '请输入邮箱地址', trigger: 'blur' },
            {
              pattern: /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((.[a-zA-Z0-9_-]{2,3}){1,2})$/,
              message: '请输入正确的邮箱地址',
              trigger: 'blur',
            },
          ],
        },
      }
    },
    created() {
      this.getUserList()
      this.getRoleList()
    },
    methods: {
      showAddUser() {
        this.addForm.wx_user_id = ''
        this.addForm.job_num = ''
        this.addForm.phonenumber = ''
        this.addForm.userName = ''
        this.addForm.nickName = ''
        this.addForm.password = ''
        this.addDialogVisible = true
      },
      userChange(ids) {
        let id = ids[ids.length - 1]
        let user = this.wxData[id]
        if (user) {
          this.addForm.wx_user_id = user.wx_user_id
          this.addForm.job_num = user.job_num
          this.addForm.phonenumber = user.phonenumber
          this.addForm.userName = user.name
          this.addForm.nickName = user.name
          this.addForm.password = user.job_num
        }
      },
      getUserList(id = '') {
        let userUrl = `/admin/v1/user?size=${this.queryInfo.pagesize}&page=${this.queryInfo.pagenum}&deptId=${id}`
        chat_get( userUrl, {}, res => {
          if(res.status == 200) {
            let { List: userList, Total } = res.data.MessageContent
            this.total = Total
            this.userlist = userList
          }
        })
      },
      // getUserAndDept() {
      //   this.getUserList()
      //   chat_get(`/admin/v1/dept`, {}, res => {
      //     if(res.status == 200) {
      //       this.deptlist = res.data.MessageContent
      //     }
      //   })
      // },
      // 监听 pagesize 改变的事件
      handleSizeChange(newSize) {
        this.queryInfo.pagesize = newSize
        this.getUserList()
      },
      // 监听 页码值 改变的事件
      handleCurrentChange(newPage) {
        // console.log(newPage)
        this.queryInfo.pagenum = newPage
        this.getUserList()
      },
      // 监听 switch 开关状态的改变
      userStateChanged(userinfo) {
        let operate = userinfo.Status ? "开启" : "停用"
        let textMsg = `确认要${operate}"${userinfo.Username}"角色吗?`
        this.$confirm(textMsg, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let params = toForm({
            userId: userinfo.Id,
            status: userinfo.Status
          })
          chat_post('/admin/v1/changeUserStatus', params, res => {
            if(res.status == 200) {
              this.$message({
                type: 'success',
                message: `${operate}成功!`
              });
            }
          })
        }).catch((err) => {
          userinfo.Status = userinfo.Status?0:1
          this.$message({
            type: 'info',
            message: '已取消操作'
          });
        });
      },
      // 监听添加用户对话框的关闭事件
      addDialogClosed() {
        this.$refs.addFormRef.resetFields()
      },
      // filterNode(value, data) {
      //   if (!value) return true;
      //   return data.DeptName.indexOf(value) !== -1;
      // },
      // handleNodeClick(val) {
      //   this.getUserList(val.Id)
      // },
      // 点击按钮，添加新用户
      addUser() {
        let vm = this;
        let copyAddForm = JSON.parse(JSON.stringify(vm.addForm))
        if(copyAddForm.roleIds) {
          copyAddForm.roleIds = copyAddForm.roleIds.join()
        }
        this.$refs.addFormRef.validate(valid => {
          if (!valid) return
          let params = toForm(copyAddForm)
          chat_post('/admin/v1/user', params, res => {
            if(res.status == 200) {
              this.$message.success('添加用户成功！')
              // 隐藏添加用户的对话框
              this.addDialogVisible = false
              // 重新获取用户列表数据
              this.getUserList()
            }
          }, err => {
            this.$message.error('请求失败')
          })
        })
      },
      getRoleList() {
        chat_get('/admin/v1/APIRole', {}, res => {
          if(res.status == 200) {
            this.roleOptions = res.data.MessageContent.List
          }
        })
      },
      // 展示编辑用户的对话框
      showEditDialog(oneInfo) {
        let vm = this;
        chat_get(`/admin/v1/userById?userId=${oneInfo.Id}`, {}, res => {
          if(res.status == 200) {
            vm.editForm = res.data.MessageContent
            vm.editForm.RoleIds = res.data.MessageContent.AdminRoleList.reduce((pre,cur) => {
              return pre.concat(cur.ID)
            },[])
          }
        })
        this.editDialogVisible = true
      },
      // 监听修改用户对话框的关闭事件
      editDialogClosed() {
        this.$refs.editFormRef.resetFields()
      },
      // 修改用户信息并提交
      editUserInfo() {
        this.$refs.editFormRef.validate(valid => {
          if (!valid) return
          let { Nickname, Mobile, login_type, Email, Id, Sex, Status, Remark, IsAdmin, RoleIds } = this.editForm
          if(RoleIds) {
            this.editForm.RoleIds = RoleIds.join()
          }
          let params = toForm({
            userId: Id,
            nickName: Nickname,
            phonenumber: Mobile,
            email: Email,
            sex: Sex,
            status: Status,
            remark: Remark,
            is_admin: IsAdmin,
            roleIds: this.editForm.RoleIds,
            login_type
          })
          chat_post('/admin/v1/upuser', params, res => {
            if(res.status == 200) {
              // 关闭对话框
              this.editDialogVisible = false
              // 刷新数据列表
              this.getUserList()
              // 提示修改成功
              this.$message.success('更新用户信息成功！')
            }
          })
        })
      },
      // 根据Id删除对应的用户信息
      removeUserById(oneUser) {
        let vm = this;
        this.$confirm( `此操作将删除用户"${oneUser.Username}", 是否继续?`, '警告', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let data = new FormData();
          data.append('ids', oneUser.Id);
          chat_del(`/admin/v1/user/${oneUser.Id}`, {}, res => {
            if(res.status == 200) {
              vm.getUserList()
              vm.$message({
                type: 'success',
                message: `删除成功!`
              });
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作'
          });
        });
      },
    }
  }
</script>

<style lang="less" scoped>
  .el-select-dropdown__item {
    padding: 0;
    text-align: center;
  }
</style>
